/**
=========================================================
* Soft UI Dashboard PRO React - v3.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Soft UI Dashboard PRO React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";

// Settings page components

function ChangePassword() {
  return (
    <Card id="change-password">
      <SuiBox p={3}>
        <SuiTypography variant="h5">Credential</SuiTypography>
      </SuiBox>
      <SuiBox component="form" pb={3} px={3}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <SuiTypography variant="h9"> Qualifications</SuiTypography>
            <SuiTypography variant="body2" color="text" fontWeight="regular">
              cervical(cone) Biopsy
            </SuiTypography>
            <SuiTypography variant="body2" color="text" fontWeight="regular">
              Colposcopy
            </SuiTypography>
            <SuiTypography variant="body2" color="text" fontWeight="regular">
              Dilation and curettage
            </SuiTypography>
          </Grid>
        </Grid>
      </SuiBox>
    </Card>
  );
}

export default ChangePassword;
